import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

export default function DataTablePagination(props) {
    const gridRef = useRef()

    const defaultColDef = useMemo(() => ({
        // flex: 1,
        resizable: true,
        // width: 200
    }), [])
    const onBtShowLoading = useCallback(() => {
        if (gridRef?.current) {
            gridRef?.current?.api?.showLoadingOverlay();
        }
    }, []);

    const onBtHide = useCallback(() => {
        if (gridRef?.current) {
            gridRef?.current?.api?.hideOverlay();
        }
    }, []);

    useEffect(() => {
        if (props.loading) {
            onBtShowLoading();
        } else {
            onBtHide();
        }
    }, [props.loading, onBtShowLoading, onBtHide]);
    return (
        <>
            {props.columnDefs ? (  <div className="ag-theme-alpine" style={{ height: props && props.height ? props.height : '60vh', width: '100%' }}>
               <AgGridReact
                    ref={gridRef}
                    rowData={props?.rowData || []}
                    columnDefs={props?.columnDefs || []}
                    defaultColDef={defaultColDef}
                    headerHeight={35}
                    rowHeight={35}
                    // pinnedBottomRowData={pinnedBottomRowData}
                    overlayLoadingTemplate={
                        '<div aria-live="polite" aria-atomic="true" style="height:100px; width:100px; background: url(https://ag-grid.com/images/ag-grid-loading-spinner.svg) center / contain no-repeat; margin: 0 auto;" aria-label="loading"></div>'
                    }
                    // getRowHeight={props.getRowHeight}
                />
            </div>)
            : (
                <p>Loading columns...</p>
            )}
        </>
    )
}
